import type { Dictionary } from '../../i18n';

/** The owner's name of a «Откуда пришли» group (promo spec 6.3); an unknown label stays as it is. */
export function sourceGroupName(group: string, t: Dictionary): string {
  switch (group) {
    case 'ig_post':
      return t.admin.sourceIgPost;
    case 'ig_bio':
      return t.admin.sourceIgBio;
    case 'th_dm':
      return t.admin.sourceThDm;
    case 'th_bio':
      return t.admin.sourceThBio;
    default:
      return group;
  }
}
